import * as UtilisationOrderModels from '../../models/utilisation-order/utilisation-order';
import { UtilisationOrderSearchModel } from '../../models/utilisation-order/utilisation-orderSearch';
import * as Models from '../../models/commonModels';

export class GetList {
  static readonly type = '[UtilisationOrder] List';
  constructor(public Search: UtilisationOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[UtilisationOrder] Set Search';
  constructor(public Search: UtilisationOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[UtilisationOrder] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[UtilisationOrder] Set List Page';
  constructor(public Search: UtilisationOrderSearchModel) { }
}

export class Insert {
  static readonly type = '[UtilisationOrder] Insert';
  constructor(public Order: UtilisationOrderModels.UtilisationOrderModel, public Version: number) { }
}

export class Set {
  static readonly type = '[UtilisationOrder] Set';
  constructor(public Order: Models.Request<UtilisationOrderModels.UtilisationOrderModel>) { }
}

export class Get {
  static readonly type = '[UtilisationOrder] Get';
  constructor(public OrderId: Models.RequestModel) { }
}

export class GetStatusDictionary {
  static readonly type = '[UtilisationOrder] Get Status Dictionary';
  constructor() { }
}

export class DisposeSearch {
  static readonly type = '[UtilisationOrder] DisposeSearch';
  constructor() { }
}
